import React, {Component} from 'react';
import {connect} from "react-redux";
import {Link} from 'react-router-dom'

import classNames from 'classnames'

import {getFlattenAttrs, isChildAttr} from "../../helpers/attributes";
import config from "../../config";

import './index.scss';


class Breadcrumbs extends Component {

  getItems() {

    const {attributes, match: {params: {attrSlug: currentAttrSlug}}} = this.props;

    let items = [],
      active = false;

    getFlattenAttrs(attributes).some(attr => {
      if (attr.slug === currentAttrSlug) {
        active = isChildAttr(attr) ? attr.parent : attr.slug;
      }
      return active;
    });

    attributes.forEach(attribute => {

      let isActive = false;

      if (attribute.slug === active) {
        isActive = true;
      }

      items.push({
        title: attribute.name,
        link: `/${config.attrBase}/${attribute.slug}`,
        isActive
      })

    });

    return items;

  }

  render() {

    const {history} = this.props,
      componentClass = classNames('breadcrumbs', this.props.className);

    return (
      <ul className={componentClass}>
        {this.getItems().map((item, key) =>
          <li
            className={classNames('breadcrumbs__item', {'breadcrumbs__item--active': item.isActive})}
            key={key}
          >
            <Link className="breadcrumbs__link" to={{
              pathname: item.link,
              state: {
                prev: history.location.pathname
              }
            }}>
              {item.title}
            </Link>
          </li>
        )}
      </ul>
    );
  }
}

export default connect(
  state => ({
    attributes: state.attributes,
  })
)(Breadcrumbs);


